/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, {useEffect, useState} from 'react'
import { Modal } from 'react-bootstrap'
import { Checkbox } from '../LandingHeader/Feedback/icons/Icons'
import { disconnectTodoistIntegration } from "../action/common";
import { useSocket } from "../../SocketContext";
import { decodeToken } from "react-jwt";
import { usePosthog } from "../../PosthogProvider";

const DisconnectOptionsModal = ({ show = true, onHide, theme }) => {
    const [selectedOptions, setSelectedOptions] = useState({
        todoist: false,
        lifeTab: false
    })
    const [submitting, setSubmitting] = useState(false)
    const [responseLog, setResponseLog] = useState([])
    const {socket} = useSocket();
    const user = decodeToken(localStorage.getItem('token'));
    const { captureEvent } = usePosthog();

    useEffect(() => {
        socket.on('disconnectTodoistProgress', handleDisconnectTodoist);
        return () => {
            socket.off('disconnectTodoistProgress', handleDisconnectTodoist);
        }
    }, [])

    useEffect(() => {
        const logElement = document.getElementById('disconnect-response-log');
        if (logElement) {
            logElement.scrollTop = logElement.scrollHeight;
        }
    }, [responseLog]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(submitting) 
            return

        setSubmitting(true)

        socket.emit('disconnectTodoist', {room: user['outseta:accountUid'], data: selectedOptions});

        // Capture disconnect event
        captureEvent('Todoist Disconnected');
    }

    const handleDisconnectTodoist = (data) => {
        const {room, message, error, disconnectComplete} = data;
        if(user['outseta:accountUid'] !== room){
            return;
        }

        if(message){
            setResponseLog(prev => [...prev, {message, disconnectComplete}]);
        }

        if(error){
            setResponseLog(prev => [...prev, {error}]);
            setSubmitting(false)
        }

        if(disconnectComplete){
            setTimeout(() => {
               onHide(true)
            }, 1000)
        }
    }

    const handleChange = (e) => {
        setSelectedOptions({
            ...selectedOptions,
            [e.target.name]: e.target.checked
        })
    }

    return (
        <Modal show={show} onHide={onHide} className="colorPicker-model">
            <Modal.Body className="modal-body-extra-padding w-[480px] my-0 mx-auto">
            <div className="full-model md-model-updates">
                <div className="full-model-body">
                    <div className="body-data bg-white dark:bg-black rounded-25">
                        <div className='ctTitle relative flex flex-col items-start gap-[2px]'>
                            <span className='darkPrimaryColor'>Disconnect Integration</span>
                            <p className='font text-xs text-gray-500 dark:text-white font-inter'>Syncing will stop, and any future changes will not reflect in Todoist</p>
                        </div>
                        <div className='flex py-[30px] pt-0 px-10 gap-[30px] items-center justify-start w-full' css={{
                            '.checkmark': {
                                top: '0px !important'
                            }
                        }}>
                            <form onSubmit={handleSubmit} onChange={handleChange}>
                                <ul>
                                    <li>
                                        <label className='flex items-center gap-[10px] font text-[14px] text-black dark:text-white'>
                                            <Checkbox disabled={submitting} colorPicker={`var(--accent-color)`} type="checkbox" name="todoist" id="disconnect-option-1" />
                                            <span>Delete all Lifetab tasks from Todoist</span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className='flex items-center gap-[10px] font text-[14px] text-black dark:text-white'>
                                            <Checkbox disabled={submitting} colorPicker={`var(--accent-color)`} type="checkbox" name="lifeTab" id="disconnect-option-2" />
                                            <span>Delete all Todoist tasks from Lifetab</span>
                                        </label>
                                    </li>
                                </ul>
                                {
                                    responseLog.length > 0 && (
                                        <div id="disconnect-response-log" className='flex flex-col gap-[10px] items-start w-full max-h-[250px] border border-gray-200 rounded-[10px] p-[10px] overflow-y-auto bg-black'>
                                            {responseLog.map((log, index) => (
                                                <p key={index} className={`font text-xs font-inter ${log?.error ? 'text-red-600' : 'text-gray-500'} ${log?.disconnectComplete ? 'text-green-600' : ''}`}>{log?.message ?? log?.error}</p>
                                            ))}
                                        </div>
                                    )
                                }
                                
                                <button className={`button primary mt-5 ${submitting ? 'disabled' : ''}`} css={{background: `var(--accent-color)`, color: 'white'}} disabled={submitting}>{submitting ? 'Disconnecting...' : 'Disconnect'}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            </Modal.Body>
    </Modal>
  )
}

export default DisconnectOptionsModal